import { FC, useState } from "react"
import { ConnectorFormValues } from "../../../../../../../types"
import ConnectorFormInput from "../../components/ConnectorFormInput"

interface AdvancedSettingsSectionProps {
  values: ConnectorFormValues
  onHeadersChange: (headersJson: string) => {
    success: boolean
    error: string | null
  }
  onTimeoutChange: (timeout: number) => void
}

const AdvancedSettingsSection: FC<AdvancedSettingsSectionProps> = ({
  values,
  onHeadersChange,
  onTimeoutChange
}) => {
  const [showAdvanced, setShowAdvanced] = useState(false)

  return (
    <div>
      <button
        type="button"
        onClick={() => setShowAdvanced(!showAdvanced)}
        className="flex items-center text-sm font-medium text-gray-700 mb-4 hover:text-gray-900"
      >
        <span className="mr-2">{showAdvanced ? "▼" : "▶"}</span>
        Advanced Settings
      </button>

      {showAdvanced && (
        <div className="space-y-4 pl-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Custom Headers (JSON)
            </label>
            <textarea
              value={JSON.stringify(values.config?.headers || {}, null, 2)}
              onChange={e => onHeadersChange(e.target.value)}
              placeholder='{\n  "Authorization": "Bearer token",\n  "X-API-Key": "your-key"\n}'
              className="w-full px-3 py-2 border border-gray-300 rounded-md font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows={5}
            />
            <p className="text-sm text-gray-500 mt-1">
              Optional custom HTTP headers for outgoing requests
            </p>
          </div>

          <ConnectorFormInput
            label="Timeout (seconds)"
            value={values.config?.timeout || 5}
            onChange={value => onTimeoutChange(parseInt(value))}
            type="number"
          />
        </div>
      )}
    </div>
  )
}

export default AdvancedSettingsSection
